import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { style: {"display":"flex","justify-content":"center","margin-top":"20px","margin-bottom":"20px"} }
const _hoisted_5 = { style: {"float":"left"} }
const _hoisted_6 = { style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":"13px"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Submit")
const _hoisted_8 = { style: {"float":"left"} }
const _hoisted_9 = { style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":"13px"} }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Submit")
const _hoisted_11 = { style: {"float":"left"} }
const _hoisted_12 = { style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":"13px"} }
const _hoisted_13 = { style: {"float":"left"} }
const _hoisted_14 = { style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":"13px"} }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Submit")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.orderType && _ctx.orderType === 'Increase')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_el_page_header, {
            content: "Add New Increase Order",
            onBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
            style: {"margin-top":"-25px","margin-bottom":"15px"}
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.orderType && _ctx.orderType === 'Decrease')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_page_header, {
            content: "Add New Decrease Order",
            onBack: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1))),
            style: {"margin-top":"-25px","margin-bottom":"15px"}
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.orderType && _ctx.orderType === 'Transfer')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_el_page_header, {
            content: "Add New Transfer Order",
            onBack: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.go(-1))),
            style: {"margin-top":"-25px","margin-bottom":"15px"}
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_card, { class: "box-card" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.orderType && _ctx.orderType === 'Increase')
            ? _withDirectives((_openBlock(), _createBlock(_component_el_form, {
                key: 0,
                ref: "increaseFormRef",
                model: _ctx.increaseForm,
                "label-width": "200px",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "Account",
                    required: "",
                    prop: "accountToId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.increaseForm.accountToId,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.increaseForm.accountToId) = $event)),
                        placeholder: "please select an account",
                        style: {"width":"50%"},
                        filterable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountsRef, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: item.source.name +'-'+item.accountName +'-'+item.accountNumber + ' '+ item.currency,
                              value: item.id
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_5, _toDisplayString(item.source.name +'-'+item.accountName +'-'+item.accountNumber), 1),
                                _createElementVNode("span", _hoisted_6, _toDisplayString(item.currency), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createTextVNode(" " + _toDisplayString(_ctx.accountsRef.filter( it => it.id === +_ctx.increaseForm.accountToId)[0] ?
                    ('AB: '+ _ctx.accountsRef.filter( it => it.id === +_ctx.increaseForm.accountToId)[0].availableBalance+' '+ _ctx.accountsRef.filter( it => it.id === +_ctx.increaseForm.accountToId)[0].currency +' | UAB: '+_ctx.accountsRef.filter( it => it.id === +_ctx.increaseForm.accountToId)[0].unavailableBalance+' '+ _ctx.accountsRef.filter( it => it.id === +_ctx.increaseForm.accountToId)[0].currency ):''), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Type",
                    required: "",
                    prop: "type"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.increaseForm.type,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.increaseForm.type) = $event)),
                        placeholder: "please select a type",
                        style: {"width":"50%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Interest",
                            value: "Interest"
                          }),
                          _createVNode(_component_el_option, {
                            label: "Received",
                            value: "Received"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Tag",
                    prop: "tag"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.increaseForm.tag,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.increaseForm.tag) = $event)),
                        style: {"width":"50%"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Change Balance Type",
                    required: "",
                    prop: "balanceTypeTo"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.increaseForm.balanceTypeTo,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.increaseForm.balanceTypeTo) = $event)),
                        placeholder: "please select a type",
                        style: {"width":"50%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Available Balance",
                            value: "Available"
                          }),
                          _createVNode(_component_el_option, {
                            label: "Unavailable Balance",
                            value: "Unavailable"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Change amount",
                    required: "",
                    prop: "amountTo"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.increaseForm.amountTo,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.increaseForm.amountTo) = $event)),
                        placeholder: "Please input amount",
                        style: {"width":"50%"}
                      }, {
                        append: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.accountsRef.filter( it => it.id === +_ctx.increaseForm.accountToId)[0] ? _ctx.accountsRef.filter( it => it.id === +_ctx.increaseForm.accountToId)[0].currency:''), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Comment",
                    prop: "comment"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.increaseForm.comment,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.increaseForm.comment) = $event)),
                        rows: 2,
                        type: "textarea",
                        style: {"width":"50%"},
                        placeholder: "Please input"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.onSubmitIncrease
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])), [
                [_directive_loading, _ctx.loadingRef]
              ])
            : _createCommentVNode("", true),
          (_ctx.orderType && _ctx.orderType === 'Decrease')
            ? _withDirectives((_openBlock(), _createBlock(_component_el_form, {
                key: 1,
                ref: "decreaseFormRef",
                model: _ctx.decreaseForm,
                "label-width": "200px",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "Account",
                    required: "",
                    prop: "accountFromId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.decreaseForm.accountFromId,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.decreaseForm.accountFromId) = $event)),
                        placeholder: "please select an account",
                        style: {"width":"50%"},
                        filterable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountsRef, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: item.source.name +'-'+item.accountName +'-'+item.accountNumber + ' '+ item.currency,
                              value: item.id
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_8, _toDisplayString(item.source.name +'-'+item.accountName +'-'+item.accountNumber), 1),
                                _createElementVNode("span", _hoisted_9, _toDisplayString(item.currency), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createTextVNode(" " + _toDisplayString(_ctx.accountsRef.filter( it => it.id === +_ctx.decreaseForm.accountFromId)[0] ?
                    ('AB: '+ _ctx.accountsRef.filter( it => it.id === +_ctx.decreaseForm.accountFromId)[0].availableBalance+' '+ _ctx.accountsRef.filter( it => it.id === +_ctx.decreaseForm.accountFromId)[0].currency +' | UAB: '+_ctx.accountsRef.filter( it => it.id === +_ctx.decreaseForm.accountFromId)[0].unavailableBalance+' '+ _ctx.accountsRef.filter( it => it.id === +_ctx.decreaseForm.accountFromId)[0].currency ):''), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Type",
                    required: "",
                    prop: "type"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.decreaseForm.type,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.decreaseForm.type) = $event)),
                        placeholder: "please select a type",
                        style: {"width":"50%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Transaction Fee",
                            value: "TransactionFee"
                          }),
                          _createVNode(_component_el_option, {
                            label: "Settlement Fee",
                            value: "SettlementFee"
                          }),
                          _createVNode(_component_el_option, {
                            label: "Paid",
                            value: "Paid"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Tag",
                    prop: "tag"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.decreaseForm.tag,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.decreaseForm.tag) = $event)),
                        style: {"width":"50%"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Change Balance Type",
                    required: "",
                    prop: "balanceTypeFrom"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.decreaseForm.balanceTypeFrom,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.decreaseForm.balanceTypeFrom) = $event)),
                        placeholder: "please select a type",
                        style: {"width":"50%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Available Balance",
                            value: "Available"
                          }),
                          _createVNode(_component_el_option, {
                            label: "Unavailable Balance",
                            value: "Unavailable"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Change amount",
                    required: "",
                    prop: "amountFrom"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.decreaseForm.amountFrom,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.decreaseForm.amountFrom) = $event)),
                        placeholder: "Please input amount",
                        style: {"width":"50%"}
                      }, {
                        append: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.accountsRef.filter( it => it.id === +_ctx.decreaseForm.accountFromId)[0] ? _ctx.accountsRef.filter( it => it.id === +_ctx.decreaseForm.accountFromId)[0].currency:''), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Comment",
                    prop: "comment"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.decreaseForm.comment,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.decreaseForm.comment) = $event)),
                        rows: 2,
                        type: "textarea",
                        style: {"width":"50%"},
                        placeholder: "Please input"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.onSubmitDecrease
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])), [
                [_directive_loading, _ctx.loadingRef]
              ])
            : _createCommentVNode("", true),
          (_ctx.orderType && _ctx.orderType === 'Transfer')
            ? _withDirectives((_openBlock(), _createBlock(_component_el_form, {
                key: 2,
                ref: "transferFormRef",
                model: _ctx.transferForm,
                "label-width": "200px",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "From Account",
                    required: "",
                    prop: "accountFromId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.transferForm.accountFromId,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.transferForm.accountFromId) = $event)),
                        placeholder: "please select an account",
                        style: {"width":"50%"},
                        filterable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountsRef, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: item.source.name +'-'+item.accountName +'-'+item.accountNumber + ' '+ item.currency,
                              value: item.id
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_11, _toDisplayString(item.source.name +'-'+item.accountName +'-'+item.accountNumber), 1),
                                _createElementVNode("span", _hoisted_12, _toDisplayString(item.currency), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createTextVNode(" " + _toDisplayString(_ctx.accountsRef.filter( it => it.id === +_ctx.transferForm.accountFromId)[0] ?
                    ('AB: '+ _ctx.accountsRef.filter( it => it.id === +_ctx.transferForm.accountFromId)[0].availableBalance+' '+ _ctx.accountsRef.filter( it => it.id === +_ctx.transferForm.accountFromId)[0].currency +' | UAB: '+_ctx.accountsRef.filter( it => it.id === +_ctx.transferForm.accountFromId)[0].unavailableBalance+' '+ _ctx.accountsRef.filter( it => it.id === +_ctx.transferForm.accountFromId)[0].currency ):''), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "To Account",
                    required: "",
                    prop: "accountToId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.transferForm.accountToId,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.transferForm.accountToId) = $event)),
                        placeholder: "please select an account",
                        style: {"width":"50%"},
                        filterable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountsRef, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: item.source.name +'-'+item.accountName +'-'+item.accountNumber + ' '+ item.currency,
                              value: item.id
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_13, _toDisplayString(item.source.name +'-'+item.accountName +'-'+item.accountNumber), 1),
                                _createElementVNode("span", _hoisted_14, _toDisplayString(item.currency), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createTextVNode(" " + _toDisplayString(_ctx.accountsRef.filter( it => it.id === +_ctx.transferForm.accountToId)[0] ?
                    ('AB: '+ _ctx.accountsRef.filter( it => it.id === +_ctx.transferForm.accountToId)[0].availableBalance+' '+ _ctx.accountsRef.filter( it => it.id === +_ctx.transferForm.accountToId)[0].currency +' | UAB: '+_ctx.accountsRef.filter( it => it.id === +_ctx.transferForm.accountToId)[0].unavailableBalance+' '+ _ctx.accountsRef.filter( it => it.id === +_ctx.transferForm.accountToId)[0].currency ):''), 1)
                    ]),
                    _: 1
                  }),
                  (_ctx.transferForm.accountFromId === _ctx.transferForm.accountToId)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: "Change Balance Type",
                        required: "",
                        prop: "balanceTypeFrom"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.transferForm.balanceTypeFrom,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.transferForm.balanceTypeFrom) = $event)),
                            placeholder: "please select a type",
                            style: {"width":"50%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "Available Balance",
                                value: "Available"
                              }),
                              _createVNode(_component_el_option, {
                                label: "Unavailable Balance",
                                value: "Unavailable"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, {
                    label: "Type",
                    required: "",
                    prop: "type"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.transferForm.type,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.transferForm.type) = $event)),
                        placeholder: "please select a type",
                        style: {"width":"50%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Adjust",
                            value: "Adjust"
                          }),
                          _createVNode(_component_el_option, {
                            label: "Exchange",
                            value: "Exchange"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Tag",
                    prop: "tag"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.transferForm.tag,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.transferForm.tag) = $event)),
                        style: {"width":"50%"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Change amount",
                    required: "",
                    prop: "amountFrom"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.transferForm.amountFrom,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.transferForm.amountFrom) = $event)),
                        placeholder: "Please input amount",
                        style: {"width":"50%"}
                      }, {
                        append: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.accountsRef.filter( it => it.id === +_ctx.transferForm.accountFromId)[0] ? _ctx.accountsRef.filter( it => it.id === +_ctx.transferForm.accountFromId)[0].currency:''), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (_ctx.transferForm.type === 'Exchange')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        label: "Conversion Rate",
                        prop: "rate"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.transferForm.rate,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.transferForm.rate) = $event)),
                            style: {"width":"50%"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, {
                    label: "Comment",
                    prop: "comment"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.transferForm.comment,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.transferForm.comment) = $event)),
                        rows: 2,
                        type: "textarea",
                        style: {"width":"50%"},
                        placeholder: "Please input"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.onSubmitTransfer
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])), [
                [_directive_loading, _ctx.loadingRef]
              ])
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ], 64))
}